<!--
  The Halloween hat on a face (Avatar): a witch hat, a pumpkin or a ghost
  that peeks over the top. Drawn to the face's size; it never takes a click.
-->
<template>
  <svg
    v-if="props.hat === 'witch'"
    viewBox="0 0 64 56"
    aria-hidden="true"
    class="pointer-events-none absolute"
    :style="place(0.9, 56 / 64, -0.05, -0.52, -14)"
  >
    <ellipse cx="32" cy="48" rx="30" ry="6" fill="var(--color-neutral-900)" />
    <path
      d="M14 47 C20 34 24 22 29 12 C32 6 38 2 46 4 C40 6 37 10 36 16 C38 26 44 38 50 47 Z"
      fill="var(--color-neutral-900)"
    />
    <path
      d="M18 40 C28 42 38 42 47 40 L49 45 C38 47.5 26 47.5 16 45 Z"
      fill="var(--color-secondary-500)"
    />
  </svg>

  <svg
    v-else-if="props.hat === 'pumpkin'"
    viewBox="0 0 64 56"
    aria-hidden="true"
    class="pointer-events-none absolute"
    :style="place(0.62, 56 / 64, 0.19, -0.4, 8)"
  >
    <path
      d="M31 16 C31 10 33 6 38 4"
      stroke="var(--color-success-700)"
      stroke-width="4"
      stroke-linecap="round"
      fill="none"
    />
    <!-- Pumpkin orange has no house token; it lives only in this drawing. -->
    <ellipse cx="20" cy="34" rx="14" ry="18" fill="#e46f14" />
    <ellipse cx="44" cy="34" rx="14" ry="18" fill="#e46f14" />
    <ellipse cx="32" cy="34" rx="13" ry="19" fill="#f28a2a" />
    <path d="M20 28 L26 28 L23 22 Z" fill="var(--color-neutral-900)" />
    <path d="M38 28 L44 28 L41 22 Z" fill="var(--color-neutral-900)" />
    <path
      d="M19 38 L24 43 L28 39 L32 43 L36 39 L40 43 L45 38 C40 46 24 46 19 38 Z"
      fill="var(--color-neutral-900)"
    />
  </svg>

  <svg
    v-else-if="props.hat === 'ghost'"
    viewBox="0 0 48 56"
    aria-hidden="true"
    class="pointer-events-none absolute"
    :style="place(0.5, 56 / 48, 0.68, -0.36, 12)"
  >
    <path
      d="M6 52 V22 C6 10 14 3 24 3 C34 3 42 10 42 22 V52 L36 47 L30 52 L24 47 L18 52 L12 47 Z"
      fill="white"
      stroke="var(--color-neutral-300)"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <ellipse cx="18" cy="22" rx="3" ry="4.5" fill="var(--color-neutral-900)" />
    <ellipse cx="30" cy="22" rx="3" ry="4.5" fill="var(--color-neutral-900)" />
    <ellipse cx="24" cy="33" rx="3.5" ry="4" fill="var(--color-neutral-900)" />
  </svg>
</template>

<script setup lang="ts">
import type { HalloweenHat } from '@/shared/composables/useHalloween'

const props = defineProps<{
  hat: HalloweenHat
  // The face's width in pixels.
  size: number
}>()

// Width, left and top as parts of the face's width; the height follows the
// drawing.
const place = (
  width: number,
  ratio: number,
  left: number,
  top: number,
  turn: number,
) => ({
  width: `${props.size * width}px`,
  height: `${props.size * width * ratio}px`,
  left: `${props.size * left}px`,
  top: `${props.size * top}px`,
  transform: `rotate(${turn}deg)`,
})
</script>
